import { createElement, installComponent } from '../utils/createElement';
import { COLOR_DARK_2, COLOR_WHITE } from '../utils/colors';

export default class SideNavLogout extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  get _event() {
    return new CustomEvent('logout', { bubbles: true, cancelable: false, composed: true });
  }

  connectedCallback() {
    const styles = createElement('style', null, `
      .sb-sidenav-logout {
        text-decoration: none;
        background-color: ${COLOR_DARK_2};
        color: ${COLOR_WHITE}50;
      }
      .sb-sidenav-logout:hover {
        color: white;
      }
    `);

    const root = createElement('a', { class: 'sb-sidenav-logout', href: '#' }, 'LO');

    root.addEventListener('click', (e) => {
      e.preventDefault();
      // eslint-disable-next-line no-underscore-dangle
      this.dispatchEvent(this._event);
    });

    this.shadowRoot.append(root, styles);
  }
}
installComponent('sb-sidenav-logout', SideNavLogout);
